import React from "react";
import { Star, Check, Phone, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const benefits = ["Build Your Seven-Figure Business", "Master the Art of Modern Marketing", "Access Exclusive Entrepreneurial Insights", "Join 400,000+ Monthly Listeners"];
  return;
}